module.exports = __webpack_public_path__ + "img/4.ed1c8298.jpg";